module.exports = __webpack_public_path__ + "static/Papa_Instumental_Long_Version.a45c3b2e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/data/Papa_Instumental_Long_Version.mp3
// module id = 212
// module chunks = 35783957827783